import React, { Component } from 'react';
import { Row, Col, Button, Input, List, message } from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import LoadingBar from 'react-redux-loading-bar';
import * as actions from './redux/actions';
import * as actionsUser from '../user/redux/actions';
import { API } from '../../helper/api';
import { url } from '../../helper/image';

const UserRow = ({ user, present, mark, add }) => (
    <div style={{ textAlign: "center", border: "1px solid #e8e8e8", padding: "16px", marginBottom: "16px" }}>
        <div style={{marginBottom: "8px"}}>
            <b>{user.firstName} {user.lastName}</b>
            <br />
            {user.promotion && `(${user.promotion.name})`}
        </div>
        <Button 
            className={present ? "ant-btn-danger" : "ant-btn-primary"}
            icon={add ? "plus" : present ? "stop" :  "cloud-upload"}
            onClick={() => add ? add(user.id) : mark(user.id, !present)} 
            style={{ position:'relative', right: '0' }}
        >{add ? "Ajouter" : present ? "Marquer absent" : "Marquer présent"}</Button>
    </div>
);

class PresenceHandler extends Component {
    state = { search: "" };

    componentDidMount() {
        if (this.props.event) {
            this.props.actions.getEvent(this.props.event.id);
        }
        if (!this.props.usersList || this.props.usersList.length === 0) {
            this.props.actions.getUsers();
        }
    }

    mark(userId, present) {
        API['post']('Booking/validate', { userId, eventId: this.props.event.id, presence: present })
            .then(() => {
                message.success(present ? "Présence validée" : "Absence corrigée");
                this.props.actions.markLocalPresence(userId, present)
            })
            .catch(() => message.error("Action impossible"))
    }

    add(userId) {
        API.post('Booking/user/', { userId, eventId: this.props.event.id })
            .then(() => {
                message.success("Utilisateur ajouté");
                this.props.actions.addLocalUser(this.props.usersList.find(user => user.id === userId), this.props.event.id);
                this.mark(userId, true);
            })
            .catch(() => message.error("Action impossible"));
    }
    
    render() {
        const openAt = moment(this.props.event.openAt, "YYYY-MM-DD HH:mm", 'fr');
        const searchFilter = user => 
            user.firstName.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1 ||
            user.lastName.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1 ||
            user.promotion.name.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
        const presents = this.props.presence.currentEvent.filter(presence => presence.present).filter(({ user }) => searchFilter(user));
        const others = this.props.presence.currentEvent.filter(presence => !presence.present).filter(({ user }) => searchFilter(user));
        const users = this.props.usersList.filter(user => this.props.presence.currentEvent.find(presence => presence.user.id === user.id) === undefined).filter(searchFilter);
        return (
            <div>
                <Row>
                    <div className="bookmark"
                        style={{ backgroundImage: "url(" + url("bookmark.png") + ")" }}>
                        <p className="day">{openAt.format('DD')}</p>
                        <p className="month">{openAt.format('MMMM').substring(0, 3)}</p>
                    </div>
                    <Col span={16} offset={4} className="title-home">
                        <h5>{this.props.event.title}</h5>
                    </Col>
                    {!this.props.addUser ?
                        (<Col span={20} offset={2} style={{ textAlign: "center" }}>
                            <Button 
                                className="ant-btn ant-btn-primary" 
                                icon="plus"
                                onClick={this.props.toggleAddUser} 
                                style={{ marginBottom: "16px", width: "100%" }}
                            >AJOUTER</Button>
                        </Col>)
                    : undefined}
                    <Col span={20} offset={2}>
                        <Input
                        placeholder="Recherche"
                        value={this.state.search}
                        onChange={(e) => this.setState({ search: e.target.value })}
                        />
                    </Col>
                    <Col span={20} offset={2} style={{ fontSize: "1.1em" }}>
                        { this.props.addUser ?
                            
                            <div style={{ marginTop: "16px" }}>
                                <h3>Ajouter un utilisateur</h3>
                                <div>
                                    {users && users.length > 0 ?
                                        <List
                                            size="large"
                                            dataSource={users}
                                            renderItem={user => <UserRow key={user.id} user={user} add={this.add.bind(this)} />} />
                                        : <LoadingBar className="loading-bar" style={{ marginTop: "-18px" }} />
                                    }
                                </div>
                            </div> :
                            <div>
                                <div style={{ marginTop: "16px" }}>
                                    <h3>Inscrits ({others.length})</h3>
                                    <div>
                                        {others.map(({ user }) => <UserRow key={user.id} user={user} mark={this.mark.bind(this)} />)}
                                    </div>
                                </div>
                                <div style={{ marginTop: "16px" }}>
                                    <h3>Présents ({presents.length})</h3>
                                    <div>
                                        {presents.map(({ user }) => <UserRow key={user.id} user={user} present mark={this.mark.bind(this)} />)}
                                    </div>
                                </div>
                            </div>
                        }
                    </Col>
                </Row>
            </div>
        );
    }
}

  /* istanbul ignore next */
  function mapStateToProps(state) {
    return {
      presence: state.presence,
      isAuth: state.authentification.isAuth,
      userEmail: state.authentification.user.email,
      usersList: state.user.list,
    };
  }
  
  /* istanbul ignore next */
  function mapDispatchToProps(dispatch) {
    return {
      actions: bindActionCreators({ ...actions, ...actionsUser }, dispatch)
    };
  }
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(PresenceHandler);


// WEBPACK FOOTER //
// ./src/features/presence/PresenceHandler.js